import { DropdownEditor, FocusImplementer } from '@approvalmax/ui';
import { ConditionWrapper } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { FC, memo } from 'react';
import { NetSuiteRefDataClientContractsModelsDocumentSublistType } from 'shared/data/webApp/v2';

import NetSuiteAmortizationSchedulesDataProvider from '../NetSuiteAmortizationSchedulesDataProvider/NetSuiteAmortizationSchedulesDataProvider';
import { NetSuiteAmortizationSchedulesV2DataProvider } from '../NetSuiteAmortizationSchedulesV2DataProvider/NetSuiteAmortizationSchedulesV2DataProvider';
import { NetSuiteLineItemAmortizationScheduleCellProps } from './NetSuiteLineItemAmortizationScheduleCell.types';

export const NetSuiteLineItemAmortizationScheduleCell: FC<NetSuiteLineItemAmortizationScheduleCellProps> = memo(
    (props) => {
        const { invalid, value, onChange, placeholder, singleLinePerItem, apiVersion = 'v1', integrationCode } = props;

        return (
            <FocusImplementer>
                {({ registerFocusable }) => (
                    <ConditionWrapper
                        condition={apiVersion == 'v1'}
                        wrapperIf={(children) => (
                            <NetSuiteAmortizationSchedulesDataProvider
                                sublistType={domain.DocumentSublistType.ExpenseList}
                            >
                                {children}
                            </NetSuiteAmortizationSchedulesDataProvider>
                        )}
                        wrapperElse={(children) => (
                            <NetSuiteAmortizationSchedulesV2DataProvider
                                sublistType={NetSuiteRefDataClientContractsModelsDocumentSublistType.LineList}
                                integrationCode={integrationCode}
                            >
                                {children}
                            </NetSuiteAmortizationSchedulesV2DataProvider>
                        )}
                    >
                        <DropdownEditor
                            ref={registerFocusable}
                            invalid={invalid}
                            value={value || null}
                            singleLinePerItem={singleLinePerItem}
                            onChange={onChange}
                            placeholder={placeholder}
                            theme='transparent'
                        />
                    </ConditionWrapper>
                )}
            </FocusImplementer>
        );
    }
);

NetSuiteLineItemAmortizationScheduleCell.displayName = 'NetSuiteLineItemAmortizationScheduleCell';
